import React, { useMemo, useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut, Bar } from "react-chartjs-2";
import { Card } from "react-bootstrap";
// import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { generateRandomColors, generateRandomColors2 } from "../../../Utils";
import useBorrowerDashboardTwo from "./apis/useBorrowerDashboardTwo";
import { ChartDetailsModal } from "../../../components/DoughnutAndMeterBorrower/DoughnutChartBorrower";

ChartJS.register(ArcElement, Tooltip, Legend);

function VisualRepresentation() {
  const [show, setShow] = useState(false);
  const { activeAccountList, accountsLength } = useBorrowerDashboardTwo();

  const LabelsData = activeAccountList?.map((data) => data.displayValue);
  const chartValues = activeAccountList?.map((data) => data.prinbal);

  const totalValue = activeAccountList?.length;
  const colors = generateRandomColors(activeAccountList?.length);
  const data = {
    labels: LabelsData,
    datasets: [
      {
        data: chartValues,
        backgroundColor: colors,
        borderWidth: 0,
        cutout: "65%",
        // radius: "80%",
        hoverOffset: 5,
      },
    ],
  };
  const textCenter = useMemo(
    () => ({
      id: "textCenter",
      beforeDatasetDraw: function (chart, a, b) {
        var width = chart.width,
          height = chart.height - 12,
          ctx = chart.ctx;

        ctx.restore();
        var fontSize = (height / 114).toFixed(2);
        ctx.font = fontSize - 1 + "rem sans-serif";
        ctx.textBaseline = "middle";

        var text = "Active Loan(s)",
          textX = Math.round((width - ctx.measureText(text).width) / 2),
          textY = height / 2;

        var text2 = totalValue,
          textX2 = Math.round((width - ctx.measureText(text2).width) / 2) - 10,
          textY2 = height / 2;

        ctx.fillText(text, textX, textY);
        ctx.fillText(text2, textX2, textY2 + 30);
        ctx.save();
      },
    }),
    [accountsLength]
  );

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  // const data =
  //   activeAccountList?.map((item, idx) => ({
  //     name: item.displayValue,
  //     value: item.prinbal,
  //     color: colors[idx],
  //   })) || [];
  return (
    <>
      <ChartDetailsModal
        handleClose={handleClose}
        // loanAgingTable={valuesToPopulate}
        show={show}
        Chart={
          <div className="col-sm-12 bg-white d-flex flex-column justify-content-center align-items-center">
            <h5>Visual Representation</h5>
            <div className="chart-container">
              <Bar
                key={accountsLength}
                options={options}
                data={data}
                height={500}
                width={1000}
                // plugins={[textCenter]}
              />
            </div>
          </div>
        }
      />
      <Card
        className="p-3 text-center border-primary h-100 visualRepresentation"
        role="button"
        onClick={accountsLength ? handleShow : null}
      >
        <h6 className="mb-3">Visual Representation</h6>
        {accountsLength ? (
          <div className="position-relative d-flex justify-content-center align-items-center">
            {/* Pie Chart */}

            <div className="w-100">
              <Bar
                key={accountsLength}
                options={options}
                data={data}
                // plugins={[textCenter]}
              />
            </div>
          </div>
        ) : (
          <p className="d-flex justify-content-center align-items-center">
            No active loans
          </p>
        )}
      </Card>
    </>
  );
}

export default VisualRepresentation;

const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false, // This hides the legend
    },
    tooltip: {
      callbacks: {
        label: (tooltipItem) => {
          const value = tooltipItem.raw;
          return `Principal Balance: $${value.toLocaleString()}`; // Change ₹ to your currency symbol
        },
        title: (tooltipItem) => {
          const value = tooltipItem[0].label;
          return `Loan Number: ${value}`;
        },
      },
    },
    datalabels: {
      color: "#fff",
      font: { weight: "bold", size: 14 },
      formatter: (value) => `$${value.toLocaleString()}`, // Currency format inside chart
    },
  },
  scales: {
    y: {
      ticks: {
        callback: function (value) {
          return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
          }).format(value);
        },
      },
    },
  },
};
